import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"system-components"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M11.9994 9.75L15.8484 12V16.5L11.9994 18.75L8.15039 16.5V12L11.9994 9.75Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M14.2223 5.25C14.2223 6.49264 13.2274 7.5 12.0001 7.5C10.7728 7.5 9.77783 6.49264 9.77783 5.25C9.77783 4.00736 10.7728 3 12.0001 3C13.2274 3 14.2223 4.00736 14.2223 5.25Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M22.0001 18.75C22.0001 19.9926 21.0052 21 19.7779 21C18.5506 21 17.5557 19.9926 17.5557 18.75C17.5557 17.5074 18.5506 16.5 19.7779 16.5C21.0052 16.5 22.0001 17.5074 22.0001 18.75Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M6.44444 18.75C6.44444 19.9926 5.44952 21 4.22222 21C2.99492 21 2 19.9926 2 18.75C2 17.5074 2.99492 16.5 4.22222 16.5C5.44952 16.5 6.44444 17.5074 6.44444 18.75Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.8491 16.5L17.9079 17.534M12 9.75V7.5M8.15077 16.5L6.09277 17.5351M11.9999 9.75L15.8489 12V16.5L11.9999 18.75L8.15088 16.5V12L11.9999 9.75ZM14.2223 5.25C14.2223 6.49264 13.2274 7.5 12.0001 7.5C10.7728 7.5 9.77783 6.49264 9.77783 5.25C9.77783 4.00736 10.7728 3 12.0001 3C13.2274 3 14.2223 4.00736 14.2223 5.25ZM22.0001 18.75C22.0001 19.9926 21.0052 21 19.7779 21C18.5506 21 17.5557 19.9926 17.5557 18.75C17.5557 17.5074 18.5506 16.5 19.7779 16.5C21.0052 16.5 22.0001 17.5074 22.0001 18.75ZM6.44444 18.75C6.44444 19.9926 5.44952 21 4.22222 21C2.99492 21 2 19.9926 2 18.75C2 17.5074 2.99492 16.5 4.22222 16.5C5.44952 16.5 6.44444 17.5074 6.44444 18.75Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SystemComponents = Vue.extend<IconProps>({
  name: 'SystemComponentsIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'system-components',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default SystemComponents;
